import { useCompany } from "#modules/company/view/useCompany";
import { isBarOrProfile, PartTypeSchema, PartTypeType } from "shared";

export const useShouldShowCustomInputs = (partType: PartTypeType | null | undefined) => {
  const { company } = useCompany();

  return (
    company?.companySettings.hasCustomInputs &&
    (partType === PartTypeSchema.enum.MACHINING || isBarOrProfile(partType))
  );
};
